<div class="flex align-items-center justify-content-start font-normal"
	[ngClass]="(onExtendedMobile()) ? 'flex-column mr-7' : 'flex-row' ">
	<!-- {{ 'DEVICE' | translate }} -->
	<div class="card pb-0 pl-4 border-round-2xl">
		<div class="grid flex align-items-center" [class]="onExtendedMobile() ? 'w-22rem' : 'w-25rem' ">
			<div class="col-2 px-0 flex justify-content-center">
				<i class="pi {{getIcon(device)}} text-4xl text-primary"></i>
				<!-- <i class="pi {{iconName}} text-4xl text-primary"></i> -->
			</div>
			<!-- <div class="col-6 flex flex-column justify-content-start px-1"> -->
			<div class="col-10 flex flex-column justify-content-start px-1">
				<div class="font-semibold" [pTooltip]="device.Name.length > maxLenghtStrShort ? device.Name: ''" tooltipPosition="top">{{
					(device!== undefined) ? getTruncate(device.Name, 'short') : ('BUTTON_NOT_SELECT' | translate) }}
				</div>
				<div [pTooltip]="device.Description.length > maxLenghtStrLong ? device.Description: ''" tooltipPosition="bottom">{{
					(device!== undefined && device.Description.length > 0) ? getTruncate(device.Description, 'long'):
					('NO_DESCRIPTION' | translate) }}
				</div>
			</div>
			<!-- NO STATUS -->
			<!-- <div class="col-4 px-0">
				<div *ngIf="deviceStatus !== undefined" class="flex align-items-center justify-content-center gap-2">
					<i *ngIf="greenPowerActive" class="pi cm-sleep text-xl text-green-600"
						[pTooltip]="'GREEN_POWER_STAND_BY' | translate" tooltipPosition="bottom"></i>
					<p-tag [value]="getStatus()" [severity]="getStatusColor()"></p-tag>
				</div>
			</div> -->
		</div>
	</div>
</div>